import { Button, Form, Input, notification, Select } from 'antd';
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { addRequestCourse, clearTutorState } from '@/actions/tutor';
import { addData, setData } from '@/actions/auth';
import { isLogin } from '@/helpers/loginHelper';
import { capitalizeFirstLetter } from '@/helpers/dataHelper';
import useWidth from '@/helpers/widthUtil';
import { useRouter } from 'next/router';

const RequestCourseForm = ({ showTitle = true }) => {
  const { isMobile } = useWidth();
  const router = useRouter();
  const currentQuery = router.query;

  const [form] = Form.useForm();
  const user = useSelector((state: any) => state.auth?.creds?.user_data);
  const addCourseRequest = useSelector(
    (state: any) => state?.tutorReducer?.addCourseRequest
  );
  const dispatch = useDispatch();
  const [data, setRequestData] = useState({
    course_name: currentQuery?.course_name || '',
    degree_type: currentQuery?.degree_type || '',
    level: currentQuery?.level || '',
    duration: currentQuery?.duration || '',
    duration_type: currentQuery?.duration_type || '',
    message: currentQuery?.message || '',
    name: currentQuery?.name || '',
    user_email: currentQuery?.user_email || '',
    phone: currentQuery?.phone || null,
  });
  const [degreeState, setDegreeState] = useState({
    academic: false,
    professional: false,
  });
  const [notificationHide, setNotificationHide] = useState(false);
  var academicList: string[] = ['SEE', '+2', 'Bachelor', 'Master', 'Entrance'];
  var proffessionalList: string[] = [
    'English Proficiency',
    'Loksewa',
    'Personality Developement',
  ];
  const [error, setError] = useState({ phone: '' });
  const requestForm = useSelector((state: any) => state?.tutorReducer?.requestForm);
  const { success: status, status: formStatus } = requestForm;

  useEffect(() => {
    clearState();
    dispatch(clearTutorState());
  }, []);

  useEffect(() => {
    setQuery();
    form.setFieldsValue(data);
  }, [router]);

  const setQuery = () => {
    Object.entries(router?.query).forEach(([k, v], i) =>
      Object.keys(data)?.map((key) => {
        if (key == k) {
          let temp = data;
          if (key == 'degree_type' || key == 'duration_type') {
            temp[k] = v.toString().toLowerCase();
          } else {
            temp[k] = v;
          }
          setRequestData(temp);
        }
      })
    );
    if (isLogin()) {
      setRequestData({
        ...data,
        name: `${capitalizeFirstLetter(user?.first_name)} ${capitalizeFirstLetter(
          user?.last_name
        )}`,
        user_email: user?.email,
      });
    }
  };

  useEffect(() => {
    if (status) {
      notification.success({
        message: 'Your Request has been succesfully submitted. Thank You!',
      });
      setRequestData({
        course_name: '',
        degree_type: '',
        level: '',
        duration: '',
        duration_type: '',
        message: '',
        name: '',
        user_email: '',
        phone: '',
      });
      setDegreeState({
        academic: false,
        professional: false,
      });
      form.resetFields();
      setError({ phone: '' });
    }
  }, [status]);

  const clearState = () => {
    dispatch(
      addData({
        key: 'requestForm',
        value: {},
      })
    );
    dispatch(
      setData({
        name: 'requestForm',
        key: 'success',
        value: false,
      })
    );
  };

  const handleSubmit = (event) => {
    if (data?.phone?.length < 10) {
      setError({ ...error, phone: 'Phone number must be atleast 10 digits' });
    } else {
      dispatch(addRequestCourse(data));
      // cancelBanner();
    }
  };

  const handleDegreeType = (value) => {
    setRequestData({ ...data, degree_type: value });
    let dType: string = value;
    if (dType == 'academic') {
      setDegreeState({ ...degreeState, academic: true });
    } else {
      setDegreeState({ professional: true, academic: false });
    }
  };
  const handleContact = (e) => {
    const { value } = e.target;
    const num = value.slice(0, 10);
    setRequestData({
      ...data,
      phone: num,
    });
  };

  return (
    <>
      {showTitle && (
        <h1 className="heading mb-4 mx-auto text-center"> Course Form</h1>
      )}
      <div
        className={`banner-form border border-muted bg-light border-14 ${
          !isMobile ? 'p-3' : 'p-2'
        }`}
      >
        {/* <form className="course-request-form" onSubmit={handleSubmit}> */}
        <Form form={form} className="course-request-form" onFinish={handleSubmit}>
          <div className="row">
            <div className="col-lg-4 col-sm-12">
              <Form.Item
                name="name"
                label="Name"
                rules={[{ required: true, message: 'Please input your full name!' }]}
              >
                <Input
                  className="border-14"
                  size="large"
                  name="name"
                  type="text"
                  placeholder="Your Full Name"
                  value={
                    // isLogin()
                    //   ? `${capitalizeFirstLetter(
                    //       user?.first_name
                    //     )} ${capitalizeFirstLetter(user?.last_name)}`
                    //   :
                    data.name
                  }
                  onChange={(e) => setRequestData({ ...data, name: e.target.value })}
                  required
                />
              </Form.Item>
            </div>
            <div className="col-lg-4">
              <Form.Item
                name="user_email"
                label="Email"
                rules={[{ required: true, message: 'Please input your email!' }]}
              >
                <Input
                  className="border-14"
                  size="large"
                  name="user_email"
                  type="email"
                  placeholder="Your Email"
                  // value={isLogin() ? `${user?.email}` : data.user_email}
                  value={data.user_email}
                  onChange={(e) =>
                    setRequestData({ ...data, user_email: e.target.value })
                  }
                  required
                  // disabled={isLogin() ? true : false}
                />
              </Form.Item>
            </div>
            <div className="col-lg-4">
              <Form.Item
                name="phone"
                label="Phone"
                rules={[
                  { required: true, message: 'Please input your phone number!' },
                ]}
              >
                <Input
                  className="border-14"
                  size="large"
                  type="text"
                  name="phone"
                  placeholder="Enter Your Phone Number"
                  value={data.phone}
                  onChange={(e) => handleContact(e)}
                  autoComplete="off"
                  pattern="\d*"
                  maxLength={10}
                />
              </Form.Item>{' '}
              {error?.phone && (
                <div className="validation">{error?.phone || ''}</div>
              )}
            </div>
          </div>
          <div className="row">
            <div className="col-lg-4">
              <Form.Item
                name="course_name"
                label="Course Name"
                rules={[{ required: true, message: 'Please input course name!' }]}
              >
                <Input
                  className="border-14"
                  size="large"
                  name="course_name"
                  type="text"
                  placeholder="Ex: BSC Physics, Organic Chemistry"
                  value={data.course_name}
                  onChange={(e) =>
                    setRequestData({ ...data, course_name: e.target.value })
                  }
                  required
                />
              </Form.Item>
            </div>
            <div className="col-lg-4">
              <Form.Item
                name="degree_type"
                label="Degree Type"
                rules={[{ required: true, message: 'Please select degree type!' }]}
              >
                <Select
                  className="border-14"
                  size="large"
                  id="selectDegreeType"
                  value={data.degree_type}
                  onChange={(e) => handleDegreeType(e)}
                  placeholder="Select a degree type"
                >
                  <Select.Option disabled>Select a degree type</Select.Option>
                  <Select.Option value="academic">Academic</Select.Option>
                  <Select.Option value="professional">Professional</Select.Option>
                </Select>
              </Form.Item>
              {/* </div> */}
            </div>
            <div className="col-lg-4">
              <Form.Item
                name="level"
                label="Level"
                rules={[{ required: true, message: 'Please select level!' }]}
              >
                <Select
                  className="border-14"
                  size="large"
                  id="level"
                  value={data.level}
                  onChange={(value: any) =>
                    setRequestData({ ...data, level: value })
                  }
                  placeholder="Select level"
                >
                  <Select.Option disabled>Select level</Select.Option>
                  {degreeState.academic
                    ? academicList.map((each, key) => (
                        <Select.Option value={each} key={key}>
                          {each}
                        </Select.Option>
                      ))
                    : proffessionalList.map((each, key) => (
                        <Select.Option value={each} key={key}>
                          {each}
                        </Select.Option>
                      ))}
                </Select>
              </Form.Item>
              {/* </div> */}
            </div>
          </div>
          <div className="row"></div>
          <div className="row">
            <div className="col-lg-6">
              <Form.Item
                name="duration"
                label="Duration"
                rules={[{ required: true, message: 'Please input the duration!' }]}
              >
                <Input
                  className="border-14"
                  size="large"
                  name="duration"
                  pattern="^[1-9]\d*(?:\.\d{1,2})?$"
                  type="number"
                  value={data.duration}
                  onChange={(e) =>
                    setRequestData({ ...data, duration: e.target.value })
                  }
                  placeholder="Duration Time Ex: 1,2"
                  autoComplete="off"
                  required
                />
              </Form.Item>
            </div>
            <div className="col-lg-6">
              <Form.Item
                name="duration_type"
                label="Duration Type"
                rules={[{ required: true, message: 'Please select duration type' }]}
              >
                <Select
                  className="border-14"
                  size="large"
                  // name="duration_type"
                  placeholder="Select a duration type"
                  id="selectDurationType"
                  value={data.duration_type}
                  onChange={(value: any) =>
                    setRequestData({ ...data, duration_type: value })
                  }
                >
                  <Select.Option disabled>Select Duration Type</Select.Option>
                  <Select.Option value="day">Day</Select.Option>
                  <Select.Option value="week">Week</Select.Option>
                  <Select.Option value="month">Month</Select.Option>
                </Select>
              </Form.Item>
              {/* </div> */}
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <Form.Item name="message" label="Message">
                <Input.TextArea
                  className="border-14 custom-textarea"
                  size="large"
                  name="message"
                  style={{ resize: 'none' }}
                  rows={4}
                  placeholder="Say something why you want this course?"
                  value={data.message}
                  onChange={(e) =>
                    setRequestData({ ...data, message: e.target.value })
                  }
                />
              </Form.Item>
            </div>
          </div>
          <div className="text-right">
            <Button
              size="large"
              htmlType="submit"
              className="col-lg-3 text-center btn-danger text-white border-danger border-14"
              loading={formStatus === 'request' ? true : false}
            >
              Submit
            </Button>
          </div>
        </Form>
      </div>
    </>
  );
};
export default RequestCourseForm;
